/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SimuladorRouteImport } from './routes/simulador'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTwoFactorSetupRouteImport } from './routes/_auth/two-factor-setup'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppFieldRouteImport } from './routes/_app/field'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppPaymentsIndexRouteImport } from './routes/_app/payments/index'
import { Route as AppLoansIndexRouteImport } from './routes/_app/loans/index'
import { Route as AppComplianceIndexRouteImport } from './routes/_app/compliance/index'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app/collections/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppCashIndexRouteImport } from './routes/_app/cash/index'
import { Route as AppBillingIndexRouteImport } from './routes/_app/billing/index'
import { Route as AppAccountingIndexRouteImport } from './routes/_app/accounting/index'
import { Route as AppReportsReportIdRouteImport } from './routes/_app/reports/$reportId'
import { Route as AppPaymentsNewRouteImport } from './routes/_app/payments/new'
import { Route as AppPaymentsPaymentIdRouteImport } from './routes/_app/payments/$paymentId'
import { Route as AppLoansPipelineRouteImport } from './routes/_app/loans/pipeline'
import { Route as AppLoansNewRouteImport } from './routes/_app/loans/new'
import { Route as AppLoansLoanIdRouteImport } from './routes/_app/loans/$loanId'
import { Route as AppClientsNewRouteImport } from './routes/_app/clients/new'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients/$clientId'
import { Route as AppCashSessionIdRouteImport } from './routes/_app/cash/$sessionId'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminInstitutionRouteImport } from './routes/_app/admin/institution'
import { Route as AppAdminDocumentsRouteImport } from './routes/_app/admin/documents'
import { Route as AppAdminBranchesRouteImport } from './routes/_app/admin/branches'
import { Route as AppAdminBillingRouteImport } from './routes/_app/admin/billing'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminAccountingRouteImport } from './routes/_app/admin/accounting'
import { Route as AppAdminProductsIndexRouteImport } from './routes/_app/admin/products/index'
import { Route as AppComplianceAlertsAlertIdRouteImport } from './routes/_app/compliance/alerts/$alertId'
import { Route as AppAdminProductsNewRouteImport } from './routes/_app/admin/products/new'
import { Route as AppAdminProductsProductIdRouteImport } from './routes/_app/admin/products/$productId'
import { Route as AppAccountingEntriesEntryIdRouteImport } from './routes/_app/accounting/entries/$entryId'

const SimuladorRoute = SimuladorRouteImport.update({
  id: '/simulador',
  path: '/simulador',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTwoFactorSetupRoute = AuthTwoFactorSetupRouteImport.update({
  id: '/two-factor-setup',
  path: '/two-factor-setup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppFieldRoute = AppFieldRouteImport.update({
  id: '/field',
  path: '/field',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIndexRoute = AppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoute,
} as any)
const AppLoansIndexRoute = AppLoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => AppRoute,
} as any)
const AppComplianceIndexRoute = AppComplianceIndexRouteImport.update({
  id: '/compliance/',
  path: '/compliance/',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppCashIndexRoute = AppCashIndexRouteImport.update({
  id: '/cash/',
  path: '/cash/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingIndexRoute = AppBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingIndexRoute = AppAccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsReportIdRoute = AppReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsNewRoute = AppPaymentsNewRouteImport.update({
  id: '/payments/new',
  path: '/payments/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsPaymentIdRoute = AppPaymentsPaymentIdRouteImport.update({
  id: '/payments/$paymentId',
  path: '/payments/$paymentId',
  getParentRoute: () => AppRoute,
} as any)
const AppLoansPipelineRoute = AppLoansPipelineRouteImport.update({
  id: '/loans/pipeline',
  path: '/loans/pipeline',
  getParentRoute: () => AppRoute,
} as any)
const AppLoansNewRoute = AppLoansNewRouteImport.update({
  id: '/loans/new',
  path: '/loans/new',
  getParentRoute: () => AppRoute,
} as any)
const AppLoansLoanIdRoute = AppLoansLoanIdRouteImport.update({
  id: '/loans/$loanId',
  path: '/loans/$loanId',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsNewRoute = AppClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppCashSessionIdRoute = AppCashSessionIdRouteImport.update({
  id: '/cash/$sessionId',
  path: '/cash/$sessionId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminInstitutionRoute = AppAdminInstitutionRouteImport.update({
  id: '/admin/institution',
  path: '/admin/institution',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminDocumentsRoute = AppAdminDocumentsRouteImport.update({
  id: '/admin/documents',
  path: '/admin/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBranchesRoute = AppAdminBranchesRouteImport.update({
  id: '/admin/branches',
  path: '/admin/branches',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBillingRoute = AppAdminBillingRouteImport.update({
  id: '/admin/billing',
  path: '/admin/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAccountingRoute = AppAdminAccountingRouteImport.update({
  id: '/admin/accounting',
  path: '/admin/accounting',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminProductsIndexRoute = AppAdminProductsIndexRouteImport.update({
  id: '/admin/products/',
  path: '/admin/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppComplianceAlertsAlertIdRoute =
  AppComplianceAlertsAlertIdRouteImport.update({
    id: '/compliance/alerts/$alertId',
    path: '/compliance/alerts/$alertId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminProductsNewRoute = AppAdminProductsNewRouteImport.update({
  id: '/admin/products/new',
  path: '/admin/products/new',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminProductsProductIdRoute =
  AppAdminProductsProductIdRouteImport.update({
    id: '/admin/products/$productId',
    path: '/admin/products/$productId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingEntriesEntryIdRoute =
  AppAccountingEntriesEntryIdRouteImport.update({
    id: '/accounting/entries/$entryId',
    path: '/accounting/entries/$entryId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/simulador': typeof SimuladorRoute
  '/dashboard': typeof AppDashboardRoute
  '/field': typeof AppFieldRoute
  '/profile': typeof AppProfileRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/login': typeof AuthLoginRoute
  '/two-factor-setup': typeof AuthTwoFactorSetupRoute
  '/admin/accounting': typeof AppAdminAccountingRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/billing': typeof AppAdminBillingRoute
  '/admin/branches': typeof AppAdminBranchesRoute
  '/admin/documents': typeof AppAdminDocumentsRoute
  '/admin/institution': typeof AppAdminInstitutionRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/cash/$sessionId': typeof AppCashSessionIdRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients/new': typeof AppClientsNewRoute
  '/loans/$loanId': typeof AppLoansLoanIdRoute
  '/loans/new': typeof AppLoansNewRoute
  '/loans/pipeline': typeof AppLoansPipelineRoute
  '/payments/$paymentId': typeof AppPaymentsPaymentIdRoute
  '/payments/new': typeof AppPaymentsNewRoute
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/accounting/': typeof AppAccountingIndexRoute
  '/billing/': typeof AppBillingIndexRoute
  '/cash/': typeof AppCashIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/collections/': typeof AppCollectionsIndexRoute
  '/compliance/': typeof AppComplianceIndexRoute
  '/loans/': typeof AppLoansIndexRoute
  '/payments/': typeof AppPaymentsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/accounting/entries/$entryId': typeof AppAccountingEntriesEntryIdRoute
  '/admin/products/$productId': typeof AppAdminProductsProductIdRoute
  '/admin/products/new': typeof AppAdminProductsNewRoute
  '/compliance/alerts/$alertId': typeof AppComplianceAlertsAlertIdRoute
  '/admin/products/': typeof AppAdminProductsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/simulador': typeof SimuladorRoute
  '/dashboard': typeof AppDashboardRoute
  '/field': typeof AppFieldRoute
  '/profile': typeof AppProfileRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/login': typeof AuthLoginRoute
  '/two-factor-setup': typeof AuthTwoFactorSetupRoute
  '/admin/accounting': typeof AppAdminAccountingRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/billing': typeof AppAdminBillingRoute
  '/admin/branches': typeof AppAdminBranchesRoute
  '/admin/documents': typeof AppAdminDocumentsRoute
  '/admin/institution': typeof AppAdminInstitutionRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/cash/$sessionId': typeof AppCashSessionIdRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/clients/new': typeof AppClientsNewRoute
  '/loans/$loanId': typeof AppLoansLoanIdRoute
  '/loans/new': typeof AppLoansNewRoute
  '/loans/pipeline': typeof AppLoansPipelineRoute
  '/payments/$paymentId': typeof AppPaymentsPaymentIdRoute
  '/payments/new': typeof AppPaymentsNewRoute
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/accounting': typeof AppAccountingIndexRoute
  '/billing': typeof AppBillingIndexRoute
  '/cash': typeof AppCashIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/compliance': typeof AppComplianceIndexRoute
  '/loans': typeof AppLoansIndexRoute
  '/payments': typeof AppPaymentsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/accounting/entries/$entryId': typeof AppAccountingEntriesEntryIdRoute
  '/admin/products/$productId': typeof AppAdminProductsProductIdRoute
  '/admin/products/new': typeof AppAdminProductsNewRoute
  '/compliance/alerts/$alertId': typeof AppComplianceAlertsAlertIdRoute
  '/admin/products': typeof AppAdminProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/simulador': typeof SimuladorRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/field': typeof AppFieldRoute
  '/_app/profile': typeof AppProfileRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/two-factor-setup': typeof AuthTwoFactorSetupRoute
  '/_app/admin/accounting': typeof AppAdminAccountingRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/billing': typeof AppAdminBillingRoute
  '/_app/admin/branches': typeof AppAdminBranchesRoute
  '/_app/admin/documents': typeof AppAdminDocumentsRoute
  '/_app/admin/institution': typeof AppAdminInstitutionRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/cash/$sessionId': typeof AppCashSessionIdRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/clients/new': typeof AppClientsNewRoute
  '/_app/loans/$loanId': typeof AppLoansLoanIdRoute
  '/_app/loans/new': typeof AppLoansNewRoute
  '/_app/loans/pipeline': typeof AppLoansPipelineRoute
  '/_app/payments/$paymentId': typeof AppPaymentsPaymentIdRoute
  '/_app/payments/new': typeof AppPaymentsNewRoute
  '/_app/reports/$reportId': typeof AppReportsReportIdRoute
  '/_app/accounting/': typeof AppAccountingIndexRoute
  '/_app/billing/': typeof AppBillingIndexRoute
  '/_app/cash/': typeof AppCashIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/compliance/': typeof AppComplianceIndexRoute
  '/_app/loans/': typeof AppLoansIndexRoute
  '/_app/payments/': typeof AppPaymentsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/accounting/entries/$entryId': typeof AppAccountingEntriesEntryIdRoute
  '/_app/admin/products/$productId': typeof AppAdminProductsProductIdRoute
  '/_app/admin/products/new': typeof AppAdminProductsNewRoute
  '/_app/compliance/alerts/$alertId': typeof AppComplianceAlertsAlertIdRoute
  '/_app/admin/products/': typeof AppAdminProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/simulador'
    | '/dashboard'
    | '/field'
    | '/profile'
    | '/change-password'
    | '/login'
    | '/two-factor-setup'
    | '/admin/accounting'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/branches'
    | '/admin/documents'
    | '/admin/institution'
    | '/admin/users'
    | '/cash/$sessionId'
    | '/clients/$clientId'
    | '/clients/new'
    | '/loans/$loanId'
    | '/loans/new'
    | '/loans/pipeline'
    | '/payments/$paymentId'
    | '/payments/new'
    | '/reports/$reportId'
    | '/accounting/'
    | '/billing/'
    | '/cash/'
    | '/clients/'
    | '/collections/'
    | '/compliance/'
    | '/loans/'
    | '/payments/'
    | '/reports/'
    | '/accounting/entries/$entryId'
    | '/admin/products/$productId'
    | '/admin/products/new'
    | '/compliance/alerts/$alertId'
    | '/admin/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/simulador'
    | '/dashboard'
    | '/field'
    | '/profile'
    | '/change-password'
    | '/login'
    | '/two-factor-setup'
    | '/admin/accounting'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/branches'
    | '/admin/documents'
    | '/admin/institution'
    | '/admin/users'
    | '/cash/$sessionId'
    | '/clients/$clientId'
    | '/clients/new'
    | '/loans/$loanId'
    | '/loans/new'
    | '/loans/pipeline'
    | '/payments/$paymentId'
    | '/payments/new'
    | '/reports/$reportId'
    | '/accounting'
    | '/billing'
    | '/cash'
    | '/clients'
    | '/collections'
    | '/compliance'
    | '/loans'
    | '/payments'
    | '/reports'
    | '/accounting/entries/$entryId'
    | '/admin/products/$productId'
    | '/admin/products/new'
    | '/compliance/alerts/$alertId'
    | '/admin/products'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/simulador'
    | '/_app/dashboard'
    | '/_app/field'
    | '/_app/profile'
    | '/_auth/change-password'
    | '/_auth/login'
    | '/_auth/two-factor-setup'
    | '/_app/admin/accounting'
    | '/_app/admin/audit'
    | '/_app/admin/billing'
    | '/_app/admin/branches'
    | '/_app/admin/documents'
    | '/_app/admin/institution'
    | '/_app/admin/users'
    | '/_app/cash/$sessionId'
    | '/_app/clients/$clientId'
    | '/_app/clients/new'
    | '/_app/loans/$loanId'
    | '/_app/loans/new'
    | '/_app/loans/pipeline'
    | '/_app/payments/$paymentId'
    | '/_app/payments/new'
    | '/_app/reports/$reportId'
    | '/_app/accounting/'
    | '/_app/billing/'
    | '/_app/cash/'
    | '/_app/clients/'
    | '/_app/collections/'
    | '/_app/compliance/'
    | '/_app/loans/'
    | '/_app/payments/'
    | '/_app/reports/'
    | '/_app/accounting/entries/$entryId'
    | '/_app/admin/products/$productId'
    | '/_app/admin/products/new'
    | '/_app/compliance/alerts/$alertId'
    | '/_app/admin/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  SimuladorRoute: typeof SimuladorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/simulador': {
      id: '/simulador'
      path: '/simulador'
      fullPath: '/simulador'
      preLoaderRoute: typeof SimuladorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/two-factor-setup': {
      id: '/_auth/two-factor-setup'
      path: '/two-factor-setup'
      fullPath: '/two-factor-setup'
      preLoaderRoute: typeof AuthTwoFactorSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/field': {
      id: '/_app/field'
      path: '/field'
      fullPath: '/field'
      preLoaderRoute: typeof AppFieldRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/': {
      id: '/_app/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AppPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loans/': {
      id: '/_app/loans/'
      path: '/loans'
      fullPath: '/loans/'
      preLoaderRoute: typeof AppLoansIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compliance/': {
      id: '/_app/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof AppComplianceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash/': {
      id: '/_app/cash/'
      path: '/cash'
      fullPath: '/cash/'
      preLoaderRoute: typeof AppCashIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/': {
      id: '/_app/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AppBillingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/': {
      id: '/_app/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAccountingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$reportId': {
      id: '/_app/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AppReportsReportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/new': {
      id: '/_app/payments/new'
      path: '/payments/new'
      fullPath: '/payments/new'
      preLoaderRoute: typeof AppPaymentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/$paymentId': {
      id: '/_app/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/payments/$paymentId'
      preLoaderRoute: typeof AppPaymentsPaymentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loans/pipeline': {
      id: '/_app/loans/pipeline'
      path: '/loans/pipeline'
      fullPath: '/loans/pipeline'
      preLoaderRoute: typeof AppLoansPipelineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loans/new': {
      id: '/_app/loans/new'
      path: '/loans/new'
      fullPath: '/loans/new'
      preLoaderRoute: typeof AppLoansNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loans/$loanId': {
      id: '/_app/loans/$loanId'
      path: '/loans/$loanId'
      fullPath: '/loans/$loanId'
      preLoaderRoute: typeof AppLoansLoanIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/new': {
      id: '/_app/clients/new'
      path: '/clients/new'
      fullPath: '/clients/new'
      preLoaderRoute: typeof AppClientsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cash/$sessionId': {
      id: '/_app/cash/$sessionId'
      path: '/cash/$sessionId'
      fullPath: '/cash/$sessionId'
      preLoaderRoute: typeof AppCashSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/institution': {
      id: '/_app/admin/institution'
      path: '/admin/institution'
      fullPath: '/admin/institution'
      preLoaderRoute: typeof AppAdminInstitutionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/documents': {
      id: '/_app/admin/documents'
      path: '/admin/documents'
      fullPath: '/admin/documents'
      preLoaderRoute: typeof AppAdminDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/branches': {
      id: '/_app/admin/branches'
      path: '/admin/branches'
      fullPath: '/admin/branches'
      preLoaderRoute: typeof AppAdminBranchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/billing': {
      id: '/_app/admin/billing'
      path: '/admin/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AppAdminBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/accounting': {
      id: '/_app/admin/accounting'
      path: '/admin/accounting'
      fullPath: '/admin/accounting'
      preLoaderRoute: typeof AppAdminAccountingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/products/': {
      id: '/_app/admin/products/'
      path: '/admin/products'
      fullPath: '/admin/products/'
      preLoaderRoute: typeof AppAdminProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compliance/alerts/$alertId': {
      id: '/_app/compliance/alerts/$alertId'
      path: '/compliance/alerts/$alertId'
      fullPath: '/compliance/alerts/$alertId'
      preLoaderRoute: typeof AppComplianceAlertsAlertIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/products/new': {
      id: '/_app/admin/products/new'
      path: '/admin/products/new'
      fullPath: '/admin/products/new'
      preLoaderRoute: typeof AppAdminProductsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/products/$productId': {
      id: '/_app/admin/products/$productId'
      path: '/admin/products/$productId'
      fullPath: '/admin/products/$productId'
      preLoaderRoute: typeof AppAdminProductsProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/entries/$entryId': {
      id: '/_app/accounting/entries/$entryId'
      path: '/accounting/entries/$entryId'
      fullPath: '/accounting/entries/$entryId'
      preLoaderRoute: typeof AppAccountingEntriesEntryIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppFieldRoute: typeof AppFieldRoute
  AppProfileRoute: typeof AppProfileRoute
  AppAdminAccountingRoute: typeof AppAdminAccountingRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminBillingRoute: typeof AppAdminBillingRoute
  AppAdminBranchesRoute: typeof AppAdminBranchesRoute
  AppAdminDocumentsRoute: typeof AppAdminDocumentsRoute
  AppAdminInstitutionRoute: typeof AppAdminInstitutionRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppCashSessionIdRoute: typeof AppCashSessionIdRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppClientsNewRoute: typeof AppClientsNewRoute
  AppLoansLoanIdRoute: typeof AppLoansLoanIdRoute
  AppLoansNewRoute: typeof AppLoansNewRoute
  AppLoansPipelineRoute: typeof AppLoansPipelineRoute
  AppPaymentsPaymentIdRoute: typeof AppPaymentsPaymentIdRoute
  AppPaymentsNewRoute: typeof AppPaymentsNewRoute
  AppReportsReportIdRoute: typeof AppReportsReportIdRoute
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
  AppBillingIndexRoute: typeof AppBillingIndexRoute
  AppCashIndexRoute: typeof AppCashIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppComplianceIndexRoute: typeof AppComplianceIndexRoute
  AppLoansIndexRoute: typeof AppLoansIndexRoute
  AppPaymentsIndexRoute: typeof AppPaymentsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppAccountingEntriesEntryIdRoute: typeof AppAccountingEntriesEntryIdRoute
  AppAdminProductsProductIdRoute: typeof AppAdminProductsProductIdRoute
  AppAdminProductsNewRoute: typeof AppAdminProductsNewRoute
  AppComplianceAlertsAlertIdRoute: typeof AppComplianceAlertsAlertIdRoute
  AppAdminProductsIndexRoute: typeof AppAdminProductsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppFieldRoute: AppFieldRoute,
  AppProfileRoute: AppProfileRoute,
  AppAdminAccountingRoute: AppAdminAccountingRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminBillingRoute: AppAdminBillingRoute,
  AppAdminBranchesRoute: AppAdminBranchesRoute,
  AppAdminDocumentsRoute: AppAdminDocumentsRoute,
  AppAdminInstitutionRoute: AppAdminInstitutionRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppCashSessionIdRoute: AppCashSessionIdRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppClientsNewRoute: AppClientsNewRoute,
  AppLoansLoanIdRoute: AppLoansLoanIdRoute,
  AppLoansNewRoute: AppLoansNewRoute,
  AppLoansPipelineRoute: AppLoansPipelineRoute,
  AppPaymentsPaymentIdRoute: AppPaymentsPaymentIdRoute,
  AppPaymentsNewRoute: AppPaymentsNewRoute,
  AppReportsReportIdRoute: AppReportsReportIdRoute,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
  AppBillingIndexRoute: AppBillingIndexRoute,
  AppCashIndexRoute: AppCashIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppComplianceIndexRoute: AppComplianceIndexRoute,
  AppLoansIndexRoute: AppLoansIndexRoute,
  AppPaymentsIndexRoute: AppPaymentsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppAccountingEntriesEntryIdRoute: AppAccountingEntriesEntryIdRoute,
  AppAdminProductsProductIdRoute: AppAdminProductsProductIdRoute,
  AppAdminProductsNewRoute: AppAdminProductsNewRoute,
  AppComplianceAlertsAlertIdRoute: AppComplianceAlertsAlertIdRoute,
  AppAdminProductsIndexRoute: AppAdminProductsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthTwoFactorSetupRoute: typeof AuthTwoFactorSetupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthTwoFactorSetupRoute: AuthTwoFactorSetupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  SimuladorRoute: SimuladorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
